import React from "react"
import { Dropdown as ReactstrapDropdown, DropdownProps } from "reactstrap"

export const Dropdown: React.FC<DropdownProps> = props => {
  return <ReactstrapDropdown {...props} />
}
